import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const CheckIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.664 6.753a1 1 0 0 1 .083 1.411l-8 9a1 1 0 0 1-1.454.043l-4-4a1 1 0 1 1 1.414-1.414l3.25 3.25 7.296-8.207a1 1 0 0 1 1.411-.083Z"
      fill="currentColor"
    />
  </IconBase>
);

export default CheckIcon;
